export default "__VITE_ASSET__efadf367__"